import React from "react";
import PlusIcon from "../../../assets/plus.svg";
import { useSelector, useDispatch } from "react-redux";
import LocationFormGroup from "./shared/locationFormGroup";
import { updateUI } from "../../../store/actions/deviceProfile";

function CreateDeviceProfileStep3() {
  const dispatch = useDispatch();
  const { formFields, locations } = useSelector((state) => ({
    formFields: state.deviceProfile.ui.form.fields,
    locations: state.deviceProfile.ui.form.fields.step3.locations,
  }));

  const handleAddLocationButton = () => {
    if (Array.isArray(locations) && locations.length >= 7) return;
    const milestones = [
      "Milestone_1",
      "Milestone_2",
      "Milestone_3",
      "Milestone_4",
      "Milestone_5",
    ];

    const usedMilestones = locations
      .filter((location) => location?.existing?.shipping?.value?.startsWith("Milestone"))
      .map((location) => location?.existing?.shipping?.value);
    const availableMilestones = milestones?.filter(
      (milestone) => !usedMilestones.includes(milestone)
    );

    const newMilestone = availableMilestones[0] || undefined; //
    dispatch(
      updateUI({
        key: "form",
        value: {
          fields: {
            ...formFields,
            step3: {
              ...formFields.step3,
              locations: [
                ...formFields.step3.locations,
                {
                  currentLocation: "",
                  existing: {
                    shipping: {
                      isValid: false,
                      class: "",
                      value: newMilestone,
                      error: "",
                    },
                    pointName: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    address: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                      mapBoxTheme: {
                        cssText: `
                      .Input {
                          height: 43px;
                          font-size: 1rem;
                          font-weight: 400;
                          color: #000;
                          font-family: system-ui;
                          pointer-events: none;
                      }
                      .ClearBtn {
                          display: none !important;
                      }
                  `,
                        variables: {
                          unit: "14px",
                          padding: "0.5em",
                          border: "1px solid",
                          borderRadius: "4px",
                          boxShadow: "none",
                        },
                      },
                    },
                    latitude: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    trigger: {
                      isValid: false,
                      class: "",
                      value: "entry and exit",
                      error: "",
                    },
                    longitude: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    radius: {
                      isValid: true,
                      class: "",
                      value: "",
                      error: "",
                    },
                    alerttype: {
                      isValid: false,
                      class: "",
                      value: "notification",
                      error: "",
                    },
                    alertgroup: {
                      isValid: false,
                      class: "",
                      value: undefined,
                      error: "",
                    },
                  },
                  new: {
                    shipping: {
                      isValid: false,
                      class: "",
                      value: newMilestone,
                      error: "",
                    },
                    pointName: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    address: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                      mapBoxTheme: {
                        cssText: `
                      .Input {
                          height: 43px;
                          font-size: 1rem;
                          font-weight: 400;
                          color: #000;
                          font-family: system-ui;
                          pointer-events: none;
                      }
                      .ClearBtn {
                          display: none !important;
                      }
                  `,
                        variables: {
                          unit: "14px",
                          padding: "0.5em",
                          border: "1px solid",
                          borderRadius: "4px",
                          boxShadow: "none",
                        },
                      },
                    },
                    latitude: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    trigger: {
                      isValid: false,
                      class: "",
                      value: "entry and exit",
                      error: "",
                    },
                    longitude: {
                      isValid: false,
                      class: "",
                      value: "",
                      error: "",
                    },
                    radius: {
                      isValid: true,
                      class: "",
                      value: "",
                      error: "",
                    },
                    alerttype: {
                      isValid: false,
                      class: "",
                      value: "notification",
                      error: "",
                    },
                    alertgroup: {
                      isValid: false,
                      class: "",
                      value: undefined,
                      error: "",
                    },
                  },
                },
              ],
            },
          },
        },
      })
    );
  };

  return (
    <React.Fragment>
      <div
        className="font-face-vzw"
        style={{
          fontWeight: 700,
          fontSize: "30px",
        }}
      >
        Locations
      </div>
      <div className="device-profile-create-modal-container py-2">
        {locations.map((location, index) => (
          <LocationFormGroup
            key={`${index}-${location?.existing?.shipping?.value}`}
            title={location?.existing?.shipping?.value}
            stateSelectorIndex={index}
          />
        ))}
        {Array.isArray(locations) && locations.length <= 6 && (
          <button
            onClick={handleAddLocationButton}
            className="w-100 add-location-btn"
          >
            <img src={PlusIcon} alt="Plus Icon" />
            <span>Add milestone</span>
          </button>
        )}
      </div>
    </React.Fragment>
  );
}

export default CreateDeviceProfileStep3;
